import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export const Wrapper = props => (_jsx("div", Object.assign({ className: classNames(['bg-white border rounded shadow-sm', props.className]) }, { children: props.children })));
